import { Component } from '@angular/core';

@Component({
    selector: 'google-map-traffic-widget',
    templateUrl: './google-map-traffic-widget.component.html',
    styleUrls: ['./google-map-traffic-widget.component.scss'],
    standalone: false
})
export class GoogleMapTrafficWidgetComponent {
  constructor() {}
}
